/*
  Verona Tempo (reviews, 30 Sep 2026): "Show more" for the product reviews (5 more per tap) and a
  tap-to-enlarge customer photo. Loaded only on pages that show at least one review
  (snippets/vt-product-reviews.liquid, sections/vt-reviews.liquid). No outside scripts.
  30 Sep 2026 (later): the "Write a review" form for signed-in customers (snippets/vt-review-write.liquid):
  opens after "Write a review" (or by itself when she comes back from signing in to #vt-review-write),
  lights the stars, shrinks a photo to at most 1600 px, and sends everything to /apps/vt-reviews/submit
  (our own backend, reviews-backend/). Answers: {ok:true} or {ok:false, code:'not_bought'|'duplicate'|...}.
*/
(function () {
  if (window.vtReviewsReady) return;
  window.vtReviewsReady = true;

  var STEP = 5;

  // "Show more": reveal the next 5 hidden reviews; the button goes away when none are left
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vt-rv-more]');
    if (!btn) return;
    var box = btn.closest('.vt-product-reviews');
    var later = box ? box.querySelectorAll('[data-vt-rv-later][hidden]') : [];
    for (var i = 0; i < later.length && i < STEP; i++) later[i].hidden = false;
    if (later[0]) {
      var first = later[0];
      first.setAttribute('tabindex', '-1');
      first.focus({ preventScroll: true });
    }
    if (later.length <= STEP) btn.hidden = true;
  });

  // Photo: open large in a dialog; close with the button, a tap outside the photo, or Esc
  var dialog = null;
  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'vt-rv-lightbox';
    var closeLabel = document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0 ? 'إغلاق' : 'Close';
    dialog.innerHTML = '<button type="button" class="vt-rv-lightbox__close" aria-label="' + closeLabel + '">&times;</button><img class="vt-rv-lightbox__img" alt="">';
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('.vt-rv-lightbox__close')) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('vt-rv-lightbox-open');
      if (dialog._opener) dialog._opener.focus();
    });
    document.body.appendChild(dialog);
    return dialog;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vt-rv-photo]');
    if (!btn) return;
    var d = getDialog();
    var img = d.querySelector('img');
    img.src = btn.getAttribute('data-vt-rv-photo');
    img.alt = btn.getAttribute('data-vt-rv-alt') || '';
    d._opener = btn;
    if (typeof d.showModal === 'function') {
      d.showModal();
      document.documentElement.classList.add('vt-rv-lightbox-open');
    } else {
      window.open(img.src, '_blank', 'noopener');
    }
  });

  // ---- "Write a review" (signed-in customers) ----
  function rwText(form) {
    try { return JSON.parse(form.querySelector('[data-vt-wr-text]').textContent); } catch (e) { return {}; }
  }
  function rwShow(form, text, kind) {
    var m = form.querySelector('[data-vt-wr-msg]');
    m.textContent = text;
    m.hidden = !text;
    m.className = 'vt-wr__msg' + (kind ? ' vt-wr__msg--' + kind : '');
  }
  function rwOpen(box, focus) {
    var btn = box.querySelector('[data-vt-wr-open]');
    var form = box.querySelector('[data-vt-wr-form]');
    if (!btn || !form) return;
    form.hidden = false;
    btn.hidden = true;
    btn.setAttribute('aria-expanded', 'true');
    if (focus) { var first = form.querySelector('input[name="rating"]'); if (first) first.focus(); }
  }
  function rwStars(fs) {
    var picked = fs.querySelector('input:checked');
    var n = picked ? Number(picked.value) : 0;
    fs.querySelectorAll('.vt-wr__star').forEach(function (l, i) { l.classList.toggle('is-on', i < n); });
  }
  // shrink a phone photo (often 4-8 MB) to a JPEG of at most 1600 px before sending
  function rwShrink(file) {
    return new Promise(function (resolve) {
      if (!file || !file.size) return resolve(null);
      if (!/^image\//.test(file.type) || !window.createImageBitmap) return resolve(file);
      createImageBitmap(file).then(function (bmp) {
        var max = 1600, s = Math.min(1, max / Math.max(bmp.width, bmp.height));
        var c = document.createElement('canvas');
        c.width = Math.round(bmp.width * s); c.height = Math.round(bmp.height * s);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        c.toBlob(function (b) { resolve(b ? new File([b], 'review-photo.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.85);
      }).catch(function () { resolve(file); });
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-vt-wr-open]');
    if (open) { rwOpen(open.closest('[data-vt-wr]'), true); return; }
    var jump = e.target.closest('a[href="#vt-review-write"]');
    if (jump) { var box = document.getElementById('vt-review-write'); if (box && box.tagName === 'DETAILS') box.open = true; else if (box) rwOpen(box, false); }
  });
  document.addEventListener('change', function (e) {
    var fs = e.target.closest('[data-vt-wr-stars]');
    if (fs) rwStars(fs);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-vt-wr-form]');
    if (!form) return;
    e.preventDefault();
    var t = rwText(form);
    var send = form.querySelector('[data-vt-wr-send]');
    var fd = new FormData(form);
    if (!fd.get('rating')) return rwShow(form, t.err_rating, 'error');
    if (String(fd.get('text') || '').trim().length < 10) return rwShow(form, t.err_text, 'error');
    if (!fd.get('consent')) return rwShow(form, t.err_consent, 'error');
    send.disabled = true;
    rwShow(form, t.sending, '');
    rwShrink(fd.get('photo')).then(function (photo) {
      fd.delete('photo');
      if (photo) fd.append('photo', photo, photo.name || 'review-photo.jpg');
      var url = form.closest('[data-vt-wr]').getAttribute('data-endpoint');
      return fetch(url, { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } });
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, code: 'general' }; });
    }).then(function (res) {
      if (res && res.ok) {
        form.querySelectorAll('input, textarea, select, button').forEach(function (el) { el.disabled = true; });
        send.hidden = true;
        rwShow(form, t.thanks, 'ok');
      } else {
        send.disabled = false;
        rwShow(form, t[(res && res.code) || 'general'] || t.general, 'error');
      }
    }).catch(function () {
      send.disabled = false;
      rwShow(form, t.general, 'error');
    });
  });
  // back from signing in (…#vt-review-write): open the form straight away
  function rwFromHash() {
    if (location.hash !== '#vt-review-write') return;
    var box = document.getElementById('vt-review-write');
    if (box && box.tagName === 'DETAILS') { box.open = true; box.scrollIntoView({ block: 'start' }); }
    else if (box) { rwOpen(box, false); box.scrollIntoView({ block: 'start' }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rwFromHash); else rwFromHash();

  // ---- Judge.me (30 Sep 2026, shorter way to write a review) ----
  // Open Judge.me's own review form: waits for Judge.me's box to finish loading (up to ~12 s), then presses its button.
  function jmOpenForm(tries) {
    var b = document.querySelector('#judgeme_product_reviews .jm-action-buttons__button, #judgeme_product_reviews .jdgm-write-rev-link');
    if (b && b.getBoundingClientRect().height > 0) {
      var box = document.getElementById('judgeme_product_reviews');
      if (box) box.scrollIntoView({ block: 'start' });
      b.click();
      return;
    }
    if (tries > 0) setTimeout(function () { jmOpenForm(tries - 1); }, 300);
  }
  // signed-in customer taps "Write a review" beside the name -> the form opens straight away
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-vt-jm-write]');
    if (!a) return;
    e.preventDefault();
    jmOpenForm(40);
  });
  // back from signing in (…?write_review=1): open the form by itself, then tidy the address
  function jmFromSignIn() {
    var params = new URLSearchParams(location.search);
    if (!params.has('write_review') || !window.vtSignedIn) return;
    params.delete('write_review');
    var q = params.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    jmOpenForm(40);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jmFromSignIn); else jmFromSignIn();
})();
